import { type Footprint, SearchModes } from '@/domainLogic/index.ts';
import type { TripCardContractFootprint } from '@lmn/lmn-components';
import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Localization } from '../../../common/Localization';
import { isNil } from '../../../Utilities';

export const hasFootprint = (footprint: Footprint | undefined): boolean =>
  !isNil(footprint?.co2kg) &&
  (footprint?.co2kg || 0) > 0 &&
  !isNil(footprint?.averageCo2Kg) &&
  (footprint?.averageCo2Kg || 0) > 0;

export const createFootprint = (footprint: Footprint | undefined): TripCardContractFootprint | undefined => {
  if (!hasFootprint(footprint)) return undefined;

  return {
    co2kg: footprint?.co2kg || 0,
    averageCo2kg: footprint?.averageCo2Kg || 0,
  };
};

type IsSustainabilityAvailable = {
  localization: Localization;
  productsData?: ProductsData;
  searchParams: SearchParams;
  hasPreselectedFlight: boolean;
};
export const isSustainabilityAvailable = ({
  localization,
  productsData,
  searchParams,
  hasPreselectedFlight,
}: IsSustainabilityAvailable): boolean => {
  if (!localization?.configValuesApp?.sustainabilityEnabled) return false;
  if ((productsData?.dealCards || [])?.length === 0) return false;

  const hasHotelEmissions = (productsData?.emissionsHotelTypes || []).length > 0;

  if (searchParams[URLParameters.SEARCH_MODE] === SearchModes.HO) {
    return hasHotelEmissions;
  }

  const hasFlightEmissions = hasPreselectedFlight && hasFootprint(productsData?.transport?.data?.[0]?.footprint);

  return hasHotelEmissions && hasFlightEmissions;
};
